var _defs, _g, _g2, _g3, _rect;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIotChart(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 451.883,
    height: 268.568,
    viewBox: "0 0 451.883 268.568",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 378,
    y: 91,
    width: 451.883,
    height: 208.568,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-2"
  }, /*#__PURE__*/React.createElement("rect", {
    x: -14,
    width: 991.64,
    height: 336.93,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-3"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 656,
    height: 317.068,
    fill: "none"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 0.5,
    y1: 0.127,
    x2: 0.505,
    y2: 1.064,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#0b637a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-2",
    x1: 0.5,
    x2: 0.5,
    y2: 1,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#323238",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })))), /*#__PURE__*/React.createElement("g", {
    id: "IoT_Chart",
    "data-name": "IoT Chart",
    transform: "translate(0 -39.432)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Scroll_Group_10",
    "data-name": "Scroll Group 10",
    transform: "translate(-378 -51.568)",
    clipPath: "url(#clip-path)",
    style: {
      mixBlendMode: "normal",
      isolation: "isolate"
    }
  }, /*#__PURE__*/React.createElement("g", {
    id: "Bar_Chart_-_ALL",
    "data-name": "Bar Chart - ALL",
    transform: "translate(145 150.013)"
  }, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "axis",
    transform: "translate(-66 -140.445)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "y-axiz",
    transform: "translate(59.14 0.432)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "y-axiz-2",
    "data-name": "y-axiz",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Lines"
  }, /*#__PURE__*/React.createElement("line", {
    id: "Line_1361",
    "data-name": "Line 1361",
    y2: 291.412,
    fill: "none",
    stroke: "#707070",
    strokeLinecap: "round",
    strokeWidth: 2
  })))), /*#__PURE__*/React.createElement("g", {
    id: "x-axiz",
    transform: "translate(-9 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Lines-2",
    "data-name": "Lines",
    transform: "translate(59.32 8.044)",
    opacity: 0.29
  }, /*#__PURE__*/React.createElement("line", {
    id: "Line_1362",
    "data-name": "Line 1362",
    x2: 1000.563,
    transform: "translate(0 283.95)",
    fill: "none",
    stroke: "#707070",
    strokeLinecap: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_1364",
    "data-name": "Line 1364",
    x2: 1000.563,
    transform: "translate(0 234.744)",
    fill: "none",
    stroke: "#707070",
    strokeWidth: 1,
    opacity: 0.25
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_1367",
    "data-name": "Line 1367",
    x2: 1000.563,
    transform: "translate(0 187.705)",
    fill: "none",
    stroke: "#707070",
    strokeWidth: 1,
    opacity: 0.25
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_1369",
    "data-name": "Line 1369",
    x2: 1000.563,
    transform: "translate(0 140.666)",
    fill: "none",
    stroke: "#707070",
    strokeWidth: 1,
    opacity: 0.25
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_1371",
    "data-name": "Line 1371",
    x2: 1000.563,
    transform: "translate(0 92.544)",
    fill: "none",
    stroke: "#707070",
    strokeWidth: 1,
    opacity: 0.25
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_1372",
    "data-name": "Line 1372",
    x2: 1000.563,
    transform: "translate(0 47.039)",
    fill: "none",
    stroke: "#707070",
    strokeWidth: 1,
    opacity: 0.25
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_1373",
    "data-name": "Line 1373",
    x2: 1000.563,
    fill: "none",
    stroke: "#707070",
    strokeWidth: 1,
    opacity: 0.25
  })), /*#__PURE__*/React.createElement("text", {
    id: "_0",
    "data-name": 0,
    transform: "translate(45 294)",
    fill: "#585858",
    fontSize: 12,
    fontFamily: "MuseoSans-300, Museo Sans",
    fontWeight: 300
  }, /*#__PURE__*/React.createElement("tspan", {
    x: -7,
    y: 0
  }, "0")), /*#__PURE__*/React.createElement("text", {
    id: "_100_K",
    "data-name": "100 K",
    transform: "translate(45 199)",
    fill: "#585858",
    fontSize: 12,
    fontFamily: "MuseoSans-300, Museo Sans",
    fontWeight: 300
  }, /*#__PURE__*/React.createElement("tspan", {
    x: -31,
    y: 0
  }, "100 K")), /*#__PURE__*/React.createElement("text", {
    id: "_50_K",
    "data-name": "50 K",
    transform: "translate(45 247)",
    fill: "#585858",
    fontSize: 12,
    fontFamily: "MuseoSans-300, Museo Sans",
    fontWeight: 300
  }, /*#__PURE__*/React.createElement("tspan", {
    x: -24,
    y: 0
  }, "50 K")), /*#__PURE__*/React.createElement("text", {
    id: "_150_K",
    "data-name": "150 K",
    transform: "translate(45 154)",
    fill: "#585858",
    fontSize: 13,
    fontFamily: "MuseoSans-300, Museo Sans",
    fontWeight: 300
  }, /*#__PURE__*/React.createElement("tspan", {
    x: -32,
    y: 0
  }, "150 K")), /*#__PURE__*/React.createElement("text", {
    id: "_200_K",
    "data-name": "200 K",
    transform: "translate(45 105)",
    fill: "#585858",
    fontSize: 12,
    fontFamily: "MuseoSans-300, Museo Sans",
    fontWeight: 300
  }, /*#__PURE__*/React.createElement("tspan", {
    x: -32,
    y: 0
  }, "200 K")), /*#__PURE__*/React.createElement("text", {
    id: "_250_K",
    "data-name": "250 K",
    transform: "translate(45 60)",
    fill: "#585858",
    fontSize: 13,
    fontFamily: "MuseoSans-300, Museo Sans",
    fontWeight: 300
  }, /*#__PURE__*/React.createElement("tspan", {
    x: -34,
    y: 0
  }, "250 K")), /*#__PURE__*/React.createElement("text", {
    id: "_300_K",
    "data-name": "300 K",
    transform: "translate(45 11)",
    fill: "#585858",
    fontSize: 12,
    fontFamily: "MuseoSans-300, Museo Sans",
    fontWeight: 300
  }, /*#__PURE__*/React.createElement("tspan", {
    x: -32,
    y: 0
  }, "300 K"))))), /*#__PURE__*/React.createElement("g", {
    id: "Scroll_Group_9",
    "data-name": "Scroll Group 9",
    transform: "translate(8 -137.513)",
    clipPath: "url(#clip-path-2)",
    style: {
      mixBlendMode: "normal",
      isolation: "isolate"
    }
  }, _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Repeat_Grid_6",
    "data-name": "Repeat Grid 6",
    transform: "translate(10)",
    clipPath: "url(#clip-path-3)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4723",
    "data-name": "Group 4723",
    transform: "translate(-18.86 0.5)"
  }, /*#__PURE__*/React.createElement("line", {
    id: "Line_1374",
    "data-name": "Line 1374",
    y2: 298.068,
    transform: "translate(22)",
    fill: "none",
    stroke: "#707070",
    strokeLinecap: "round",
    strokeWidth: 1,
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("text", {
    id: "_1",
    "data-name": 1,
    transform: "translate(21.86 313.568)",
    fill: "#585858",
    fontSize: 12,
    fontFamily: "MuseoSans-300, Museo Sans",
    fontWeight: 300
  }, /*#__PURE__*/React.createElement("tspan", {
    x: -2,
    y: 0
  }, "1"))), /*#__PURE__*/React.createElement("g", {
    id: "Group_4724",
    "data-name": "Group 4724",
    transform: "translate(22.14 0.5)"
  }, /*#__PURE__*/React.createElement("line", {
    id: "Line_1375",
    "data-name": "Line 1375",
    y2: 298.068,
    transform: "translate(22)",
    fill: "none",
    stroke: "#707070",
    strokeLinecap: "round",
    strokeWidth: 1,
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("text", {
    id: "_2",
    "data-name": 2,
    transform: "translate(21.86 313.568)",
    fill: "#585858",
    fontSize: 12,
    fontFamily: "MuseoSans-300, Museo Sans",
    fontWeight: 300
  }, /*#__PURE__*/React.createElement("tspan", {
    x: -3,
    y: 0
  }, "2"))), /*#__PURE__*/React.createElement("g", {
    id: "Group_4725",
    "data-name": "Group 4725",
    transform: "translate(63.14 0.5)"
  }, /*#__PURE__*/React.createElement("line", {
    id: "Line_1376",
    "data-name": "Line 1376",
    y2: 298.068,
    transform: "translate(22)",
    fill: "none",
    stroke: "#707070",
    strokeLinecap: "round",
    strokeWidth: 1,
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("text", {
    id: "_3",
    "data-name": 3,
    transform: "translate(21.86 313.568)",
    fill: "#585858",
    fontSize: 12,
    fontFamily: "MuseoSans-300, Museo Sans",
    fontWeight: 300
  }, /*#__PURE__*/React.createElement("tspan", {
    x: -3,
    y: 0
  }, "3"))), /*#__PURE__*/React.createElement("g", {
    id: "Group_4726",
    "data-name": "Group 4726",
    transform: "translate(104.14 0.5)"
  }, /*#__PURE__*/React.createElement("line", {
    id: "Line_1377",
    "data-name": "Line 1377",
    y2: 298.068,
    transform: "translate(22)",
    fill: "none",
    stroke: "#707070",
    strokeLinecap: "round",
    strokeWidth: 1,
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("text", {
    id: "_4",
    "data-name": 4,
    transform: "translate(21.86 313.568)",
    fill: "#585858",
    fontSize: 12,
    fontFamily: "MuseoSans-300, Museo Sans",
    fontWeight: 300
  }, /*#__PURE__*/React.createElement("tspan", {
    x: -3,
    y: 0
  }, "4"))), /*#__PURE__*/React.createElement("g", {
    id: "Group_4727",
    "data-name": "Group 4727",
    transform: "translate(145.14 0.5)"
  }, /*#__PURE__*/React.createElement("line", {
    id: "Line_1378",
    "data-name": "Line 1378",
    y2: 298.068,
    transform: "translate(22)",
    fill: "none",
    stroke: "#707070",
    strokeLinecap: "round",
    strokeWidth: 1,
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("text", {
    id: "_5",
    "data-name": 5,
    transform: "translate(21.86 313.568)",
    fill: "#585858",
    fontSize: 12,
    fontFamily: "MuseoSans-300, Museo Sans",
    fontWeight: 300
  }, /*#__PURE__*/React.createElement("tspan", {
    x: -3,
    y: 0
  }, "5"))), /*#__PURE__*/React.createElement("g", {
    id: "Group_4728",
    "data-name": "Group 4728",
    transform: "translate(186.14 0.5)"
  }, /*#__PURE__*/React.createElement("line", {
    id: "Line_1379",
    "data-name": "Line 1379",
    y2: 298.068,
    transform: "translate(22)",
    fill: "none",
    stroke: "#707070",
    strokeLinecap: "round",
    strokeWidth: 1,
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("text", {
    id: "_6",
    "data-name": 6,
    transform: "translate(21.86 313.568)",
    fill: "#585858",
    fontSize: 12,
    fontFamily: "MuseoSans-300, Museo Sans",
    fontWeight: 300
  }, /*#__PURE__*/React.createElement("tspan", {
    x: -3,
    y: 0
  }, "6"))), /*#__PURE__*/React.createElement("g", {
    id: "Group_4729",
    "data-name": "Group 4729",
    transform: "translate(227.14 0.5)"
  }, /*#__PURE__*/React.createElement("line", {
    id: "Line_1380",
    "data-name": "Line 1380",
    y2: 298.068,
    transform: "translate(22)",
    fill: "none",
    stroke: "#707070",
    strokeLinecap: "round",
    strokeWidth: 1,
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("text", {
    id: "_7",
    "data-name": 7,
    transform: "translate(21.86 313.568)",
    fill: "#585858",
    fontSize: 12,
    fontFamily: "MuseoSans-300, Museo Sans",
    fontWeight: 300
  }, /*#__PURE__*/React.createElement("tspan", {
    x: -3,
    y: 0
  }, "7"))), /*#__PURE__*/React.createElement("g", {
    id: "Group_4730",
    "data-name": "Group 4730",
    transform: "translate(268.14 0.5)"
  }, /*#__PURE__*/React.createElement("line", {
    id: "Line_1381",
    "data-name": "Line 1381",
    y2: 298.068,
    transform: "translate(22)",
    fill: "none",
    stroke: "#707070",
    strokeLinecap: "round",
    strokeWidth: 1,
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("text", {
    id: "_8",
    "data-name": 8,
    transform: "translate(21.86 313.568)",
    fill: "#585858",
    fontSize: 12,
    fontFamily: "MuseoSans-300, Museo Sans",
    fontWeight: 300
  }, /*#__PURE__*/React.createElement("tspan", {
    x: -3,
    y: 0
  }, "8"))), /*#__PURE__*/React.createElement("g", {
    id: "Group_4731",
    "data-name": "Group 4731",
    transform: "translate(309.14 0.5)"
  }, /*#__PURE__*/React.createElement("line", {
    id: "Line_1382",
    "data-name": "Line 1382",
    y2: 298.068,
    transform: "translate(22)",
    fill: "none",
    stroke: "#707070",
    strokeLinecap: "round",
    strokeWidth: 1,
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("text", {
    id: "_9",
    "data-name": 9,
    transform: "translate(21.86 313.568)",
    fill: "#585858",
    fontSize: 12,
    fontFamily: "MuseoSans-300, Museo Sans",
    fontWeight: 300
  }, /*#__PURE__*/React.createElement("tspan", {
    x: -3,
    y: 0
  }, "9"))), /*#__PURE__*/React.createElement("g", {
    id: "Group_4732",
    "data-name": "Group 4732",
    transform: "translate(350.14 0.5)"
  }, /*#__PURE__*/React.createElement("line", {
    id: "Line_1383",
    "data-name": "Line 1383",
    y2: 298.068,
    transform: "translate(22)",
    fill: "none",
    stroke: "#707070",
    strokeLinecap: "round",
    strokeWidth: 1,
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("text", {
    id: "_10",
    "data-name": 10,
    transform: "translate(21.86 313.568)",
    fill: "#585858",
    fontSize: 12,
    fontFamily: "MuseoSans-300, Museo Sans",
    fontWeight: 300
  }, /*#__PURE__*/React.createElement("tspan", {
    x: -6,
    y: 0
  }, "10"))), /*#__PURE__*/React.createElement("g", {
    id: "Group_4733",
    "data-name": "Group 4733",
    transform: "translate(391.14 0.5)"
  }, /*#__PURE__*/React.createElement("line", {
    id: "Line_1384",
    "data-name": "Line 1384",
    y2: 298.068,
    transform: "translate(22)",
    fill: "none",
    stroke: "#707070",
    strokeLinecap: "round",
    strokeWidth: 1,
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("text", {
    id: "_11",
    "data-name": 11,
    transform: "translate(21.86 313.568)",
    fill: "#585858",
    fontSize: 12,
    fontFamily: "MuseoSans-300, Museo Sans",
    fontWeight: 300
  }, /*#__PURE__*/React.createElement("tspan", {
    x: -5,
    y: 0
  }, "11"))), /*#__PURE__*/React.createElement("g", {
    id: "Group_4734",
    "data-name": "Group 4734",
    transform: "translate(432.14 0.5)"
  }, /*#__PURE__*/React.createElement("line", {
    id: "Line_1385",
    "data-name": "Line 1385",
    y2: 298.068,
    transform: "translate(22)",
    fill: "none",
    stroke: "#707070",
    strokeLinecap: "round",
    strokeWidth: 1,
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("text", {
    id: "_12",
    "data-name": 12,
    transform: "translate(21.86 313.568)",
    fill: "#585858",
    fontSize: 12,
    fontFamily: "MuseoSans-300, Museo Sans",
    fontWeight: 300
  }, /*#__PURE__*/React.createElement("tspan", {
    x: -6,
    y: 0
  }, "12"))), /*#__PURE__*/React.createElement("g", {
    id: "Group_4735",
    "data-name": "Group 4735",
    transform: "translate(473.14 0.5)"
  }, /*#__PURE__*/React.createElement("line", {
    id: "Line_1386",
    "data-name": "Line 1386",
    y2: 298.068,
    transform: "translate(22)",
    fill: "none",
    stroke: "#707070",
    strokeLinecap: "round",
    strokeWidth: 1,
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("text", {
    id: "_13",
    "data-name": 13,
    transform: "translate(21.86 313.568)",
    fill: "#585858",
    fontSize: 12,
    fontFamily: "MuseoSans-300, Museo Sans",
    fontWeight: 300
  }, /*#__PURE__*/React.createElement("tspan", {
    x: -6,
    y: 0
  }, "13"))), /*#__PURE__*/React.createElement("g", {
    id: "Group_4736",
    "data-name": "Group 4736",
    transform: "translate(514.14 0.5)"
  }, /*#__PURE__*/React.createElement("line", {
    id: "Line_1387",
    "data-name": "Line 1387",
    y2: 298.068,
    transform: "translate(22)",
    fill: "none",
    stroke: "#707070",
    strokeLinecap: "round",
    strokeWidth: 1,
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("text", {
    id: "_14",
    "data-name": 14,
    transform: "translate(21.86 313.568)",
    fill: "#585858",
    fontSize: 12,
    fontFamily: "MuseoSans-300, Museo Sans",
    fontWeight: 300
  }, /*#__PURE__*/React.createElement("tspan", {
    x: -6,
    y: 0
  }, "14"))), /*#__PURE__*/React.createElement("g", {
    id: "Group_4737",
    "data-name": "Group 4737",
    transform: "translate(555.14 0.5)"
  }, /*#__PURE__*/React.createElement("line", {
    id: "Line_1388",
    "data-name": "Line 1388",
    y2: 298.068,
    transform: "translate(22)",
    fill: "none",
    stroke: "#707070",
    strokeLinecap: "round",
    strokeWidth: 1,
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("text", {
    id: "_15",
    "data-name": 15,
    transform: "translate(21.86 313.568)",
    fill: "#585858",
    fontSize: 12,
    fontFamily: "MuseoSans-300, Museo Sans",
    fontWeight: 300
  }, /*#__PURE__*/React.createElement("tspan", {
    x: -6,
    y: 0
  }, "15"))), /*#__PURE__*/React.createElement("g", {
    id: "Group_4738",
    "data-name": "Group 4738",
    transform: "translate(596.14 0.5)"
  }, /*#__PURE__*/React.createElement("line", {
    id: "Line_1389",
    "data-name": "Line 1389",
    y2: 298.068,
    transform: "translate(22)",
    fill: "none",
    stroke: "#707070",
    strokeLinecap: "round",
    strokeWidth: 1,
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("text", {
    id: "_16",
    "data-name": 16,
    transform: "translate(21.86 313.568)",
    fill: "#585858",
    fontSize: 12,
    fontFamily: "MuseoSans-300, Museo Sans",
    fontWeight: 300
  }, /*#__PURE__*/React.createElement("tspan", {
    x: -6,
    y: 0
  }, "16"))))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "Values",
    transform: "translate(10.236 1.597)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4753",
    "data-name": "Group 4753",
    transform: "translate(-10.236 90.471)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5870",
    "data-name": "Path 5870",
    d: "M2.764,167.768s20.587,3.518,41.053,19.7S64.1,215.5,84.625,232.5s20.639,44.8,41.278,22.984,20.639-70.712,41.278-110.231,21.01-66.76,41.531-46.942,20.1,101.462,40.555,126.214,20.991-24.509,41.278-27.206,19.466,18.88,39.871,16.417,20.991-9.147,41.747-26.268,20.639-33.538,41.278-42.216,20.873,3.635,41.278,7.505,20.17-3.166,40.34,7.974,20.052,29.9,40.34,36.587,20.17-8.209,40.809-9.85,21.108-9.85,41.747,3.284,21.191,95.161,21.191,95.161L658.762,318.7,59.943,334.329-51.024,301.508Z",
    transform: "translate(10.236 -90.471)",
    stroke: "#2079eb",
    strokeWidth: 2,
    fill: "url(#linear-gradient)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_4754",
    "data-name": "Group 4754",
    transform: "translate(723.489 88.471)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3180",
    "data-name": "Rectangle 3180",
    width: 35,
    height: 117,
    transform: "translate(-104.725 80)",
    fill: "#323238"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3105",
    "data-name": "Rectangle 3105",
    width: 15,
    height: 15,
    rx: 7.5,
    transform: "translate(-113.725 94)",
    fill: "#ec2870"
  }))))))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3179",
    "data-name": "Rectangle 3179",
    width: 446.884,
    height: 174.284,
    transform: "translate(0 133.716)",
    fill: "url(#linear-gradient-2)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIotChart);
export default __webpack_public_path__ + "static/media/iotChart.c18a80e71c061666137a8d9ddacdd352.svg";
export { ForwardRef as ReactComponent };